import styles from '../SessionsAuthHeader.module.css'
import {MarkGithubIcon} from '@primer/octicons-react'

export interface AnimatedUserAvatarProps {
  userName: string
  avatarUrl: string
}

const AnimatedUserAvatar = ({avatarUrl, userName}: AnimatedUserAvatarProps) => {
  return (
    <>
      <div className={styles.authFormHeaderIcon}>
        <div className={styles.authFormAvatarWrapper}>
          <div className={styles.authFormAvatarCoin}>
            <div className={styles.avatarCoinWeight} />
          </div>
          <div className={styles.authFormAvatarCoin}>
            <div className={styles.avatarCoinCover}>
              <MarkGithubIcon className={styles.avatarCoinGithub} size={48} />
            </div>
            <div className={styles.avatarCoinInnerCover} />
            <div className={styles.avatarCoinBack}>
              {avatarUrl ? <img src={avatarUrl} alt={`Avatar of ${userName}`} className={styles.userAvatar} /> : null}
            </div>
            <div className={styles.avatarCoinInnerBack} />
          </div>
        </div>
      </div>
    </>
  )
}

export default AnimatedUserAvatar
